var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 15,
    viewBox: "0 0 41 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3536 5.02834C21.3308 7.00172 22.9571 8.10302 24.1823 8.75774C25.4411 9.42958 25.8639 9.86035 25.8591 10.4611C25.8494 11.3806 24.8549 11.7863 23.924 11.8021C22.344 11.829 21.4075 11.3484 20.6666 10.968L20.6053 10.9366L20.0204 13.9388C20.7735 14.3196 22.168 14.6515 23.6141 14.666C27.0085 14.666 29.2294 12.8283 29.2414 9.97891C29.2493 7.81563 27.6156 6.87484 26.3082 6.122C25.4302 5.61641 24.6994 5.1956 24.712 4.5462C24.7228 4.05614 25.1492 3.53316 26.0837 3.40011C26.5461 3.33292 27.8229 3.28155 29.2703 4.01267L29.8384 1.10793C29.0601 0.797041 28.0595 0.499323 26.8139 0.499323C23.6189 0.499323 21.3716 2.36204 21.3536 5.02834ZM35.2975 0.749455C34.6777 0.749455 34.1552 1.14598 33.9222 1.75459L29.0732 14.4524H32.4652L33.1403 12.4066L37.2854 12.4066L37.6769 14.4524H40.6665L38.0577 0.749455H35.2975ZM36.7507 9.59669L35.7718 4.45115L34.0698 9.59669H36.7507ZM17.241 0.749455L14.5673 14.4524H17.7995L20.472 0.749455H17.241ZM9.09483 10.0762L12.4592 0.749455H15.8536L10.6167 14.4524L7.20065 14.4524L4.62302 3.51719C4.46688 2.84403 4.33115 2.59637 3.8555 2.31314C3.07837 1.84944 1.79557 1.41603 0.666504 1.14729L0.743376 0.749455H6.24335C6.94361 0.749455 7.5742 1.26058 7.73395 2.14584L9.09483 10.0762Z",
    fill: "#95A4FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.08de92494d859aac79bf1f2bec8227ab.svg";
export { ForwardRef as ReactComponent };